import type { CategoryLetterGroup } from "@/types/directory";

export const categoryIndexPartA: CategoryLetterGroup[] = [
  {
    letter: "A",
    categories: [
      { name: "Aadhaar & PAN Card Centres", count: 30 },
      { name: "Abacus Classes", count: 6 },
      { name: "AC Sales & Service", count: 80 },
      { name: "Accounting & Book Keeping", count: 19 },
      { name: "Acupressure Clinics", count: 7 },
      { name: "Acupuncture Clinics", count: 6 },
      { name: "Adhesive Dealers", count: 9 },
      { name: "Advertising & Marketing Agencies", count: 68 },
      { name: "Advocates & Lawyers", count: 120 },
      { name: "Aerobic Classes", count: 8 },
      { name: "Agarbatti Manufacturers", count: 5 },
      { name: "Agricultural & Farm Equipment Dealers", count: 35 },
      { name: "Agro Products", count: 18 },
      { name: "Air Ambulance Services", count: 3 },
      { name: "Air Cargo Services", count: 6 },
      { name: "Air Ticket Booking", count: 12 },
      { name: "Alarm System Dealers", count: 10 },
      { name: "Allergy Doctors", count: 5 },
      { name: "Alternative Medicine", count: 9 },
      { name: "Aluminium Works", count: 16 },
      { name: "Ambulance Services", count: 14 },
      { name: "Amusement Parks", count: 7 },
      { name: "Animation Studios", count: 4 },
      { name: "Aquarium Shops", count: 5 },
      { name: "Architectural Consultants", count: 23 },
      { name: "Art Galleries", count: 8 },
      { name: "Artificial Jewellery", count: 14 },
      { name: "Astrology Consultants", count: 16 },
      { name: "Audiologists", count: 9 },
      { name: "Auditoriums", count: 13 },
      { name: "Auditors & Cost Accountants", count: 25 },
      { name: "Auto Parts & Accessories Dealers", count: 67 },
      { name: "Automobile Dealers", count: 73 },
      { name: "Automobile Finance", count: 12 },
      { name: "Automobile Repair & Service Centres", count: 314 },
      { name: "Ayurvedic Clinics", count: 21 },
      { name: "Ayurvedic Doctors", count: 27 },
    ],
  },
  {
    letter: "B",
    categories: [
      { name: "Baby Shops", count: 18 },
      { name: "Bag Dealers", count: 13 },
      { name: "Bail Bonds", count: 4 },
      { name: "Bakery & Confectionery", count: 94 },
      { name: "Bakery Equipment", count: 8 },
      { name: "Bands & Orchestras", count: 6 },
      { name: "Banquet Halls & Wedding Venues", count: 65 },
      { name: "Bar Code Dealers", count: 5 },
      { name: "Barbeque Restaurants", count: 11 },
      { name: "Bars & Pubs", count: 19 },
      { name: "Bathroom Fittings & Sanitary Ware", count: 43 },
      { name: "Battery Dealers", count: 17 },
      { name: "Bearing Dealers", count: 7 },
      { name: "Beauty Academies", count: 12 },
      { name: "Beauty Clinics", count: 15 },
      { name: "Beauty Salons & Parlours", count: 179 },
      { name: "Belt & Buckle Manufacturers", count: 6 },
      { name: "Bengali Restaurants", count: 5 },
      { name: "Beverages", count: 9 },
      { name: "Bicycle Dealers", count: 16 },
      { name: "Bike On Rent", count: 11 },
      { name: "Bike Service Centres", count: 37 },
      { name: "Bill Printing Machine Dealers", count: 5 },
      { name: "Billiard Halls", count: 6 },
      { name: "Biogas Plants", count: 4 },
      { name: "Biometric Equipment", count: 7 },
      { name: "Birthday Party Organisers", count: 13 },
      { name: "Blood Banks & Donation Centres", count: 17 },
      { name: "Boat Dealers", count: 5 },
      { name: "Book Publishers", count: 8 },
      { name: "Book Shops & Dealers", count: 47 },
      { name: "Borewell Contractors", count: 19 },
      { name: "Boutiques", count: 33 },
      { name: "Bowling", count: 5 },
      { name: "Boxing Classes", count: 6 },
      { name: "BPO & Call Centres", count: 14 },
      { name: "Brass & Bronze Products", count: 7 },
      { name: "Brick Manufacturers", count: 11 },
      { name: "Bridal Wear Shops", count: 22 },
      { name: "Builders, Contractors & Developers", count: 201 },
      { name: "Building Material Dealers", count: 41 },
      { name: "Bulk SMS Providers", count: 6 },
      { name: "Bus & Van Rental Services", count: 27 },
      { name: "Bus Ticketing Agents", count: 9 },
      { name: "Business Brokers", count: 6 },
      { name: "Business & Management Consultants", count: 43 },
      { name: "Business Schools", count: 5 },
    ],
  },
  {
    letter: "C",
    categories: [
      { name: "Cable TV Operators", count: 14 },
      { name: "CAD & CAM Services", count: 7 },
      { name: "Calendar & Diaries", count: 5 },
      { name: "Camera Dealers", count: 9 },
      { name: "Camera Repairs", count: 11 },
      { name: "Cancer Hospitals", count: 6 },
      { name: "Candle Manufacturers", count: 5 },
      { name: "Cane Furniture Shops", count: 6 },
      { name: "Carpenters", count: 34 },
      { name: "Carpet Dealers", count: 12 },
      { name: "CAT Coaching Centres", count: 5 },
      { name: "Cattle Feed Dealers", count: 9 },
      { name: "CCTV Dealers", count: 22 },
      { name: "Ceiling Works", count: 11 },
      { name: "Cement Dealers", count: 24 },
      { name: "Ceramic Dealers", count: 13 },
      { name: "Chartered Accountants", count: 47 },
      { name: "Chemical Dealers", count: 19 },
      { name: "Chemistry Coaching Classes", count: 11 },
      { name: "Chest Specialists", count: 8 },
      { name: "Children & Kids Wear", count: 53 },
      { name: "Chinese Restaurants", count: 18 },
      { name: "Chocolate Dealers", count: 12 },
      { name: "Churches", count: 31 },
      { name: "Civil Services Coaching", count: 6 },
      { name: "Clocks & Accessories", count: 7 },
      { name: "Clothing & Apparel Stores", count: 134 },
      { name: "Co-Working Spaces", count: 9 },
      { name: "Coaching & Tuition Centres", count: 90 },
      { name: "Coconut Exporters", count: 7 },
      { name: "Coffee Shops & Cafés", count: 37 },
      { name: "Coir Products", count: 6 },
      { name: "Cold Storages", count: 8 },
      { name: "Colleges & Universities", count: 34 },
      { name: "Community Halls & Convention Centres", count: 24 },
      { name: "Computer & Laptop Dealers", count: 45 },
      { name: "Computer Repairs", count: 31 },
      { name: "Contact Lens Dealers", count: 12 },
      { name: "Cooking Classes", count: 8 },
      { name: "Cosmetic Surgery Clinics", count: 7 },
      { name: "Cosmetics Dealers", count: 22 },
      { name: "Courier, Cargo & Logistics Services", count: 45 },
      { name: "Cranes & Lifts", count: 9 },
      { name: "Cricket Academies", count: 12 },
      { name: "Curtain Dealers", count: 14 },
    ],
  },
  {
    letter: "D",
    categories: [
      { name: "Dairy Products", count: 21 },
      { name: "Dance Classes", count: 31 },
      { name: "Data Recovery Services", count: 6 },
      { name: "Day Care & Pre-Schools", count: 48 },
      { name: "Decorators & Event Decoration", count: 36 },
      { name: "Dental Colleges", count: 3 },
      { name: "Dentists & Dental Clinics", count: 75 },
      { name: "Departmental Stores", count: 18 },
      { name: "Dermatologists & Skin Specialists", count: 26 },
      { name: "Diagnostic & Pathology Labs", count: 66 },
      { name: "Driving Schools", count: 14 },
      { name: "Dry Cleaning & Laundry Services", count: 53 },
      { name: "Dry Fruits Dealers", count: 13 },
      { name: "DTH Services", count: 8 },
      { name: "Dyeing Units", count: 6 },
    ],
  },
  {
    letter: "E",
    categories: [
      { name: "E-Commerce Consultants", count: 7 },
      { name: "Educational Consultants", count: 15 },
      { name: "Educational Institutions", count: 29 },
      { name: "Electric Motor Dealers", count: 11 },
      { name: "Electricians & Electrical Contractors", count: 84 },
      { name: "Electronics & Electrical Goods Dealers", count: 51 },
      { name: "Emergency Services", count: 15 },
      { name: "Embroidery & Zari Services", count: 23 },
      { name: "Engineers & Engineering Consultants", count: 67 },
      { name: "ENT Specialists", count: 13 },
      { name: "Entrance Exam Coaching", count: 21 },
      { name: "Event & Wedding Management", count: 52 },
      { name: "Eye Hospitals & Clinics", count: 24 },
    ],
  },
  {
    letter: "F",
    categories: [
      { name: "Fancy Stores", count: 19 },
      { name: "Fashion Designers", count: 11 },
      { name: "Fashion Institutes", count: 7 },
      { name: "Fast Food Centres & Food Courts", count: 42 },
      { name: "Fertilizer Dealers", count: 12 },
      { name: "Financial & Investment Advisors", count: 74 },
      { name: "Fire & Safety Equipment Dealers", count: 17 },
      { name: "Fish Dealers", count: 27 },
      { name: "Florists", count: 17 },
      { name: "Flour Mills", count: 10 },
      { name: "Foam Dealers", count: 7 },
      { name: "Food Processors", count: 13 },
      { name: "Football Academies", count: 9 },
      { name: "Footwear & Shoe Dealers", count: 60 },
      { name: "Furniture Dealers & Shops", count: 67 },
    ],
  },
  {
    letter: "G",
    categories: [
      { name: "Game Parlours", count: 7 },
      { name: "Gas Agencies", count: 16 },
      { name: "Gate Manufacturers", count: 9 },
      { name: "Generator Dealers", count: 21 },
      { name: "Gift Shops", count: 24 },
      { name: "Glass Dealers", count: 18 },
      { name: "Government Offices", count: 27 },
      { name: "Granite, Marble & Stone Dealers", count: 40 },
      { name: "Grocery, Ration & Supermarkets", count: 115 },
      { name: "Gyms & Fitness Centres", count: 74 },
      { name: "Gynaecologists & Women's Health", count: 52 },
    ],
  },
  {
    letter: "H",
    categories: [
      { name: "Hair Salons & Barber Shops", count: 74 },
      { name: "Hair Transplant Clinics", count: 8 },
      { name: "Handicrafts", count: 16 },
      { name: "Handloom Stores", count: 12 },
      { name: "Hardware Stores", count: 34 },
      { name: "Health & Organic Food Stores", count: 23 },
      { name: "Cardiologists & Heart Specialists", count: 39 },
      { name: "Home Appliances", count: 31 },
      { name: "Home Automation", count: 9 },
      { name: "Home Cleaning & Housekeeping Services", count: 38 },
      { name: "Home Decor", count: 24 },
      { name: "Home Nursing", count: 12 },
      { name: "Homeopathy Clinics", count: 18 },
      { name: "Homestays & Guest Houses", count: 47 },
      { name: "Hospitals", count: 34 },
      { name: "Hostels & Youth Hostels", count: 36 },
      { name: "Hotels", count: 73 },
    ],
  },
  {
    letter: "I",
    categories: [
      { name: "Ice Cream Dealers", count: 23 },
      { name: "Immigration Consultants", count: 11 },
      { name: "Import Export Consultants", count: 9 },
      { name: "Income Tax Consultants", count: 26 },
      { name: "Industrial Equipment", count: 14 },
      { name: "Information Technology", count: 46 },
      { name: "Insurance Agents & Brokers", count: 95 },
      { name: "Interior Designers", count: 28 },
      { name: "Internet Service Providers", count: 13 },
      { name: "Iron & Steel Dealers", count: 19 },
      { name: "IT & Software Companies", count: 46 },
      { name: "IT & Computer Training Institutes", count: 36 },
    ],
  },
  {
    letter: "J",
    categories: [
      { name: "Jaggery Dealers", count: 7 },
      { name: "JCB Hiring", count: 11 },
      { name: "Jewellery Dealers", count: 103 },
      { name: "Jewellery Manufacturers & Goldsmiths", count: 35 },
      { name: "Job & Recruitment Consultants", count: 70 },
      { name: "Juice Centres", count: 18 },
      { name: "Jute Products Dealers", count: 6 },
    ],
  },
  {
    letter: "K",
    categories: [
      { name: "Karate Classes", count: 9 },
      { name: "Key Makers & Locksmiths", count: 21 },
      { name: "Kitchen Equipment & Ware Dealers", count: 28 },
      { name: "Kulfi Dealers", count: 6 },
    ],
  },
  {
    letter: "L",
    categories: [
      { name: "Land Surveyors", count: 9 },
      { name: "Language Classes", count: 12 },
      { name: "Laser Clinics", count: 8 },
      { name: "Law Colleges", count: 4 },
      { name: "Libraries", count: 11 },
      { name: "Lifts & Elevators", count: 17 },
      { name: "Lighting Dealers", count: 16 },
      { name: "Lubricants Dealers", count: 10 },
    ],
  },
  {
    letter: "M",
    categories: [
      { name: "Machine Tools Dealers", count: 11 },
      { name: "Machining Services", count: 14 },
      { name: "Magazine Publishers", count: 5 },
      { name: "Makeup Artists & Bridal Makeup", count: 52 },
      { name: "Marriage Bureaus", count: 9 },
      { name: "Massage Centres", count: 27 },
      { name: "Maths Coaching Classes", count: 21 },
      { name: "Mattress Dealers", count: 14 },
      { name: "Meat, Poultry & Chicken Dealers", count: 62 },
      { name: "Media & Entertainment", count: 42 },
      { name: "Medical & Nursing Colleges", count: 13 },
      { name: "Medical Equipment Dealers", count: 17 },
      { name: "Mehndi Artists", count: 12 },
      { name: "Metal Dealers", count: 15 },
      { name: "Milk Dealers", count: 23 },
      { name: "Mobile Phone Dealers", count: 76 },
      { name: "Mobile Phone Repairs", count: 39 },
      { name: "Modelling Agencies", count: 6 },
      { name: "Money Exchange", count: 11 },
      { name: "Motorcycle Dealers", count: 28 },
      { name: "Movie Theatres & Cinema Halls", count: 28 },
      { name: "Music Classes", count: 16 },
      { name: "Musical Instruments & Music Stores", count: 26 },
    ],
  },
];